<template>

    <!-- Page Sidebar Ends-->
    <div class="container-fluid  bg-primary ">
            <div class="page-title">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/logo.png"
                                    alt="looginpage">
                </div>
               
              </div>
            </div>
          </div>
          <div class="page-body m-0">
            
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="">
           

             
             <div class="card p-3 shadow">
            <!-- <div class="card-header">
                <h4 class="card-title">Add</h4>
            </div> -->
        <div class="card-body row">

                <div class="col-md-6 col-12 position-relative">
                    <label class="form-label text-danger">Visitor Contact</label>
                    <input class="form-control" type="tel"
                        v-model="visitor.contact"   @input="acceptNumber()" maxlength="10"  pattern="[0-9]*"
                        placeholder="Type Here..." required  >
                        <span class="text-danger"  ></span>
                </div>
                <div class="col-md-6 col-12 position-relative">
                    <label class="form-label text-danger">Visitor Name</label>
                    <input class="form-control" type="text" v-model="visitor.name"  placeholder="Type Here..." v-capitalize/>
                
                </div>

                <div class="col-md-6 col-12 position-relative">
                    <label class="form-label text-danger">Visitor Designation</label>
                    <input class="form-control" type="text"  :readonly="visitor.isSelected"
                        v-model="visitor.designation" placeholder="Type Here..." required v-capitalize>
                </div>
                
            

            <div class="col-md-6 col-12 position-relative">
                <label for="visitorfrmname" class="form-label text-danger">Visitor Company Name</label>
                <!--<input class="form-control" type="text" v-model="visitor.firmname" placeholder="Type Here..." -->
                <!--    autocomplete="off"  v-capitalize/>-->
                 <Autocomplete :items="firmlist" labelField="firmname" valueField="firmname"
                                placeholder="Search Company Here" @select="handleSelect" :modelValue="query" @input-change="handleIp" />
               
            </div>

            <div class="col-md-6 col-12 position-relative">
                <label class="form-label text-danger">Visitor Address</label>
                <input class="form-control" type="text" 
                    v-model="visitor.address" placeholder="Type Here..." required v-capitalize>
            </div>

            <div class="col-md-6 col-12 position-relative">
                <label class="form-label text-danger">Schedule Date</label>
                <input class="form-control" type="date" v-model="visitor.schedule_date" v-capitalize
                    placeholder="Type Here..." required>
            </div>

                  <div class="col-md-6 col-12 position-relative">
                    <label class="form-label text-danger">Accessories</label>
                    <input class="form-control" type="text" 
                        v-model="visitor.accessories" placeholder="Type Here..." required v-capitalize>
                </div>
              
              
                 <div class="col-md-6 col-12 position-relative">
                
                    <label class="form-label text-danger">User Image</label><br>
                  <img :src="getUserImage(visitor)" @error="handleVisitorImageError" @click="openModel(visitor)" alt="User Image"  style="height: 50px; width: 50px;"  />
                </div>
                        <div class="form-group">
                                <label class="col-form-label  text-danger">Respective Authority</label>
                                <!--  <Autocomplete -->
                                <!--      :items="emp_list" -->
                                <!--      labelField="empname" -->
                                <!--      valueField="id"-->
                                <!--      placeholder="Search Staff To Meet"-->
                                <!--      @select="handleSelectStaff" />-->
                                
                                 <select id="select2" class="form-control" v-model="visitor.whom_userid">
                                     <option value="0" disabled="" selected="">SELECT STAFF</option>
                                      <option v-for="emp in emp_list" :key="emp.id" :value="emp.id">
                                        {{ emp.empname }}
                                      </option>
                                    </select>
                            </div>
                            
                            
            
            <div class="col-md-12 col-12 position-relative mt-2">
                <label class="form-label text-danger">Visit Purpose</label>
                <!--<input class="form-control" type="text" -->
                <!--    v-model="visitor.purpose" placeholder="Type Here..." required v-capitalize>-->
                 <select v-model="visitor.purpose" class="form-select">
                                      <option disabled selected>Select Purpose</option>
                                      <option v-for="purpose in purpose_list" :key="purpose" :value="purpose">
                                        {{ purpose }}
                                      </option>
                                    </select>
            </div>

<h3 class="text-danger" v-if="already_exist">{{already_exist}}</h3>
         
    </div>
    
    <div class="card-footer col-12 row">
        <div class="col-6  text-start">
        <button class="btn btn-danger" @click="this.$router.go(-1);">Go Back</button>
       </div> <div class="col-6  text-end">
            <button class="btn btn-primary" @click="save_visitor(0)">Create Gatepass</button>
        </div>
        <!-- <button class="btn btn-primary" @click="save_visitor(1)">Save And Print</button> -->
    </div>
</div>























              <!-- end---------------------------------------------------------------------------------->











                </div>
            </div>
        </div>
    </div>


<!-- model -->
<!-- Modal Trigger Button -->
<div>
    <!-- <button class="btn btn-primary" @click="openModel">Open Modal</button> -->

    <!-- Modal -->
    <div class="modal" v-if="showModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Capture The Image</h5>
            <button type="button" class="close" @click="closeModel" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 row text-center">
                <div class="col-12">
            <video ref="video" autoplay playsinline width="100%" height="auto"></video>
            <canvas ref="canvas" style="display: none;"></canvas>
           </div>
           <div class="col-12">
            <div v-if="capturedImage" class="mt-2">
              <p>Captured Image:</p>
              <img :src="capturedImage" alt="Captured" class="img-fluid" />
            </div>
            </div>
             <div class="col-12 text-center">
            <button class="btn btn-sm btn-secondary mt-2" @click="captureImage">Capture</button>
          </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-primary" @click="savechanges">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
 <!-- model -->









</template>

<style scoped>
.select2-selection {
    padding: 0.30rem 0.50rem !important;
    border: 1px solid #000000!important;
    font-weight: 600!important;
    height: 35px !important;
}
    .form-control {
    padding: 0.30rem 0.50rem !important;
    border: 1px solid #000000;
    font-weight: 600;
}
.col-md-6{
        margin-bottom: 10px;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'TabGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getEmps(0);
    },
    watch: {
         emp_list() {
            this.$nextTick(() => {
              if ($('#select2').hasClass('select2-hidden-accessible')) {
                $('#select2').select2('destroy');
              }
              this.initSelect2();
            });
          }
        },
data() {
        return {
            showModel:false,
            capturedImage: null,

            filteredFirmNames:[],
            filteredNames:[],
            purpose_list:[],
            firmlist:[],
            query:'',

            // accessories:{
            //     gatepassid:'',
            //     names: [''] // Initial empty array with one input field
            // },

            visitors: [
                    {
                        name: '',
                        contact: '',
                        designation: '',
                        accessories:''
                    }
                ],

            visitor: { whom_userid:0,photo: '',name: '', capurred_photo:'',accessories:'', firmname: '', contact: '', address: '', purpose: '', designation: '', schedule_date: this.todayDate() },

            showModal:false,
            current_visitor_row_here:[],
            filteredVisitorNames:[],
            
                showSuggestions: false,
                hidedocSuggestions: false,
                showSuggestionsvisitname: false,
                shownameSuggestions: false,
            
            emp_list:[],
            already_exist:'',

        }
    },
    methods: {

       

    //11.05.2025 
    handleSelectStaff(selectedStaff) {
        
      this.visitor.whom_userid= selectedStaff.id;
    },

            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },




          
     
      


         
 
           

          
        acceptNumber() {
                
                this.visitor.contact = this.visitor.contact.toString().replace(/\D/g, '');
                if (this.visitor.contact.toString().length == 10) {
                    // alert(this.visitor.contact.toString().length );
                    var self = this;
                    axios.post('getVisitorContactDetails', { contact_no: this.visitor.contact }).then(function (response) {
                        if (response.data.is == 1 && response.data.user){
                            self.visitor = response.data.user;
                            self.query= response.data.user?.firmname;
                        }
                            // alert(self.query);
                        window.scrollTo(0, 0);
                    });
                }
            },

         


            openModel(visitor_row_here) {
                this.current_visitor_row_here=visitor_row_here;

            this.showModel = true;
            this.startWebcam();
            },

            closeModel() {
            this.showModel = false;
            this.stopWebcam();
            },
            
            startWebcam() {
            if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
                navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    const videoElement = this.$refs.video;
                    if (videoElement) {
                    videoElement.srcObject = stream;
                    videoElement.play();
                    } else {
                    console.error("Video element not found.");
                    }
                })
                .catch((err) => {
                    console.error("Error accessing webcam: ", err);
                });
            } else {
                alert("Webcam not supported in this browser.");
                console.error("navigator.mediaDevices or getUserMedia not available.");
            }
            },

        stopWebcam() {
        const video = this.$refs.video;
        const stream = video.srcObject;
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            video.srcObject = null;
        }
        },


    captureImage() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      this.capturedImage = canvas.toDataURL('image/png');
      this.visitor.capurred_photo=this.capturedImage;
      this.capturedImage=null;
      this.showModel = false;
      this.stopWebcam();
    },

 
handleVisitorImageError(event){
    event.target.src = `${this.$hostname}/writable/visitors/user.png`;
},
    getUserImage(visitor_row_here) {
  // Check if the visitor has a photo
  if (visitor_row_here && visitor_row_here.capurred_photo) {
    // If photo is in Base64 format, return it directly
    if (visitor_row_here.capurred_photo.startsWith('data:image')) {
      return visitor_row_here.capurred_photo;
    }
    // Otherwise, return file-based image from server path
    return `${this.$hostname}/writable/uploads/visitors/${visitor_row_here.photo}`;
  }else if (visitor_row_here && visitor_row_here.photo){
       return `${this.$hostname}/writable/uploads/visitors/${visitor_row_here.photo}`;
  }

  // If no photo exists, return the default placeholder
  return `${this.$hostname}/writable/visitors/user.png`;
},









  savechanges(){
    this.showModel=false;
  },
 
            hidenameSuggestions() {
            // Add delay so click registers before hiding
            setTimeout(() => {
                this.shownameSuggestions = false;
            }, 100);
            },


// for visitor name-------------------------------------------------------------------------------------------------


save_visitor() {
                var self = this;
// alert(self.visitor.capurred_photo);
                if(self.visitor.name == ''){
                    self.$swal("Enter Visitor Name");
                }else if(self.visitor.name == ''){
                    self.$swal("Enter Visitor Name");
                }else if(!self.visitor.purpose ||  self.visitor.purpose == ''){
                    self.$swal("Enter Visit Purpose");
                }else if(self.visitor.firmname == ''){
                    self.$swal("Enter Firm Name");
                }else if(self.visitor.address == ''){
                    self.$swal("Enter Address");
                }else if(!self.visitor.capurred_photo){
                    self.$swal("Please Capture Image");
                }else if(!self.visitor.whom_userid || self.visitor.whom_userid==0){
                    self.$swal("Please Select Staff To Meet");
                }else{

                const formData = new FormData();

                 

                            if (self.visitor.capurred_photo && self.visitor.capurred_photo.startsWith('data:image')) {
                             const blob = self.dataURLtoBlob(self.visitor.capurred_photo);
                             
                            
                             formData.append(`visitor_accessories[]`, (self.visitor.accessories??''));
                       
                             formData.append(`visitor_name[]`, self.visitor.name);
                             formData.append(`visitor_contact[]`, self.visitor.contact);
                             formData.append(`visitor_designation[]`, self.visitor.designation);
                             formData.append(`photo_0`, blob , `visitor_0.png`); 
                        }

                        



                // formData.append('name', self.visitor.name);
                formData.append('firmname', self.visitor.firmname);
                // formData.append('contact', self.visitor.contact); 
                formData.append('purpose', self.visitor.purpose);
                formData.append('schedule_date', self.visitor.schedule_date);
                formData.append('address', self.visitor.address);
                formData.append('whom_userid', self.visitor.whom_userid);
                // formData.append('designation', self.visitor.designation); 



                axios.post('createGatePasssecurity_Tab', formData,{
                      headers: {
                        'Content-Type': 'multipart/form-data',
                      },
                    })
                    .then(response => {
                        var msg = '';
                        var gatepass_success = response.data.gatepass_success;
                        var visitor_success = response.data.visitor_success;
                        self.already_exist = response.data.already_exist;

                        msg = response.data.gatepass_statusmsg;
                        if (gatepass_success==1){
                            
                            // window.open(window.location.origin + "/vp?q=" + response.data.pass_data[0].token, '_blank');
                            
                            //27.06.2025
                            self.$router.replace({
                                      path: '/vp',
                                      query: {
                                        q: response.data.pass_data[0].token
                                      }
                                    });

                            
                        } 
                            self.$swal(msg);
                    //   visitor: { whom_userid:0,photo: '',name: '', accessories:'', firmname: '', contact: '', address: '', purpose: '', designation: '', schedule_date: this.todayDate() },

                        
            
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }

            },
          getEmps(id=0) {
            var self = this;
            axios.post('getEmployeesForPassCreationTab_V1' ).then(function (response) {
               
            
                
                self.emp_list = response.data.employees; 
                self.purpose_list = response.data.purpose_list; 
                self.firmlist = response.data.firmlist; 
                
                
                $("#select2").select2();
                
            });
        },

        // Converts base64 to Blob (binary)
        // base64ToBlob(base64, contentType = '') {
        //     const byteCharacters = atob(base64);
        //     const byteNumbers = new Array(byteCharacters.length);
        //     for (let i = 0; i < byteCharacters.length; i++) {
        //         byteNumbers[i] = byteCharacters.charCodeAt(i);
        //     }
        //     const byteArray = new Uint8Array(byteNumbers);
        //     return new Blob([byteArray], { type: contentType });
        // },

        base64ToBlob(base64, contentType = '') {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        },

         dataURLtoBlob(dataURL) {
          const byteString = atob(dataURL.split(',')[1]);
          const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ab], { type: mimeString });
        },
        
        //15.05.2025
        initSelect2() {
            const self = this;
            $('#select2')
              .off('select2:select') // Avoid duplicate handlers
              .on('select2:select', function (e) {
                const selectedId = e.params.data.id;
                self.visitor.whom_userid= selectedId;
                
                // console.log("Selected employee ID:", selectedId);
              });
        
            $('#select2').select2();
          }, 

    //06.07.2025
        handleSelect(selectedItem) {
                            console.log(selectedItem);
                            this.visitor.firmname = selectedItem.firmname;
                            this.query = selectedItem.firmname;
                        },
                        
            handleIp(txt) {
                            console.log(txt);
                            this.visitor.firmname = txt;
                            this.query = txt;
                        },

          
    }
}
</script>
<style scoped>
.modal {
  z-index: 1050;
}
</style>